import React, { useState } from "react";
import { Modal, Button, Input, message } from "antd";
import Api from "./api/Api";

const AbrirTurno = ({ open, onClose, onTurnoAberto }) => {
  const [loading, setLoading] = useState(false);
  const [valorInicial, setValorInicial] = useState("");

  const abrirTurno = async () => {
    setLoading(true);

    try {
      const payload = { inicial: valorInicial };
      const r = await Api.AbrirTurno(payload);

      if (r.id_turno) {
        localStorage.setItem("id_turno", r.id_turno);
        message.success("Turno aberto com sucesso");

 if (onTurnoAberto) {
  await Promise.resolve(onTurnoAberto(r));
}

setTimeout(onClose, 50);  

      }
    } catch (e) {
      message.error("Erro ao abrir turno");
    }

    setLoading(false);
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
    >
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>Abrir Turno</h2>

      <label>Valor Inicial</label>
      <Input
        placeholder="0"
        value={valorInicial}
        onChange={(e) => setValorInicial(e.target.value)}
        style={{ marginBottom: 20 }}
      />

      <div style={{ display: "flex", gap: 10 }}>
        <Button block onClick={onClose} disabled={loading}>
          Cancelar
        </Button>

        <Button
          type="primary"
          block
          loading={loading}
          onClick={abrirTurno}
        >
          Confirmar
        </Button>
      </div>
    </Modal>
  );
};

export default AbrirTurno;
